import { Alert, AlertProps } from "@mui/material";
import { styled } from "@mui/material/styles";

// Inline status message with the same look as the snackbars: the tone's `main`
// colour as surface and its `contrastText` as ink, in both colour schemes. MUI's
// own `filled` variant switches to `dark` in dark mode and its `standard` variant
// tints, which made alerts and toasts of the same status look unrelated.
const StyledAlert = styled(Alert)(({ theme }) => {
  const tone = (name: "error" | "warning" | "info" | "success") => ({
    backgroundColor: theme.vars.palette[name].main,
    color: theme.vars.palette[name].contrastText,
    "& .MuiAlert-icon, & .MuiAlert-action": {
      color: theme.vars.palette[name].contrastText,
    },
  });
  return {
    borderRadius: "6px",
    "& .MuiAlert-message": { flex: 1 },
    "& .MuiAlert-icon": { alignItems: "center" },
    "&.MuiAlert-colorError": tone("error"),
    "&.MuiAlert-colorWarning": tone("warning"),
    "&.MuiAlert-colorInfo": tone("info"),
    "&.MuiAlert-colorSuccess": tone("success"),
  };
});

const AppAlert = (props: AlertProps) => (
  <StyledAlert variant="filled" {...props} />
);

export default AppAlert;
